import React from "react";
import Pages from "../../common/Pages";
const DashboardOverlay = () => {
  return (
    <div
      className="pb-8 pt-6 px-12 h-full"
      style={{ backgroundColor: "#F9F9F9" }}
    >
      <Pages>Dashboard Overlay</Pages>
    </div>
  );
};

export default DashboardOverlay;
